import React, { type FC, type PropsWithChildren } from 'react';

import { ABTest, LogoQuoteBlock, Container } from '@lucid/components-react';
import type { ExternalLogos, I18n, Lucid } from 'types/types';
import { withPrefix } from 'gatsby';

import quoteData from './quoteData.json';

interface ABTestNewSocialProofProps {
  pathname: string;
  shortLangPrefix: I18n.AvailableLanguages;
}

const logos = ['amazon', 'intel', 'masterclass', 'atlassian'] as ExternalLogos.LogoSlug[];

const ABTestNewSocialProof: FC<PropsWithChildren<ABTestNewSocialProofProps>> = ({
  children,
  pathname,
  shortLangPrefix,
}) => (
  <ABTest
    branchesToRender={['T_A', 'T_B', 'T_C', 'T_D']}
    css={(theme: Lucid.Theme) => ({ background: theme.colors.coolGrey[5] })}
    testName="FY24Q1_ChartBrandedNewSocialProof"
    trigger="visible"
    willTriggerFire={pathname === withPrefix('/landing') && shortLangPrefix === 'en'}
  >
    <ABTest.Branch as="span" branch="T_A">
      {children}
    </ABTest.Branch>
    <Container>
      <ABTest.Branch branch="T_B">
        <LogoQuoteBlock {...quoteData[0]} logos={logos} />
      </ABTest.Branch>
      <ABTest.Branch branch="T_C">
        <LogoQuoteBlock {...quoteData[1]} logos={logos} />
      </ABTest.Branch>
      <ABTest.Branch branch="T_D">
        <LogoQuoteBlock {...quoteData[2]} logos={logos} />
      </ABTest.Branch>
    </Container>
  </ABTest>
);

export default ABTestNewSocialProof;
